/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Home_V2_Filter_Trigger_UnfiledInputs */

const en_home_v2_filter_trigger_unfiled = /** @type {(inputs: Home_V2_Filter_Trigger_UnfiledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filters: ${i?.type}, not in a folder`)
};

const es_home_v2_filter_trigger_unfiled = /** @type {(inputs: Home_V2_Filter_Trigger_UnfiledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filtros: ${i?.type}, sin carpeta`)
};

/**
* | output |
* | --- |
* | "Filters: {type}, not in a folder" |
*
* @param {Home_V2_Filter_Trigger_UnfiledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_filter_trigger_unfiled = /** @type {((inputs: Home_V2_Filter_Trigger_UnfiledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Filter_Trigger_UnfiledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_filter_trigger_unfiled(inputs)
	return en_home_v2_filter_trigger_unfiled(inputs)
});